module.exports = __webpack_public_path__ + "img/step-full.80026c13.svg";